import { useAuthStore, AdminRole } from "../stores/authStore";

const ROLE_LABELS: Record<AdminRole, string> = {
  root: "Root", admin: "Admin", support_l2: "Support L2", support_l1: "Support L1",
};

export default function ImpersonationBanner() {
  const { assumedRole, role, setAssumedRole } = useAuthStore();
  if (!assumedRole) return null;

  return (
    <div style={{
      background: "rgba(245,158,11,0.15)", borderBottom: "1px solid rgba(245,158,11,0.3)",
      padding: "8px 20px", display: "flex", alignItems: "center", gap: 10, fontSize: 12,
    }}>
      <span style={{ fontSize: 16 }}>⚠️</span>
      <span style={{ color: "#fcd34d", fontWeight: 700 }}>Viewing as {ROLE_LABELS[assumedRole]}</span>
      <span style={{ color: "var(--text-muted)" }}>— your actual role is {ROLE_LABELS[role!]}. Actions are logged under your real identity.</span>
      <span style={{ flex: 1 }} />
      <button onClick={() => setAssumedRole(null)}
        style={{ background: "rgba(245,158,11,0.25)", border: "1px solid rgba(245,158,11,0.4)", borderRadius: 7, padding: "3px 12px", color: "#fcd34d", fontWeight: 700, fontSize: 11 }}>
        ✕ Exit
      </button>
    </div>
  );
}
